import { type WalletAmountAllocation } from 'src/core/modules/company/wallet';

export const walletAmountAllocationToCheckForMissingFunds: WalletAmountAllocation =
  'total';
